import { render, staticRenderFns } from "./PermissionScanButton.vue?vue&type=template&id=a7fd1862&scoped=true"
import script from "./PermissionScanButton.vue?vue&type=script&lang=js"
export * from "./PermissionScanButton.vue?vue&type=script&lang=js"
import style0 from "./PermissionScanButton.vue?vue&type=style&index=0&id=a7fd1862&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7fd1862",
  null
  
)

export default component.exports